module.exports = __webpack_public_path__ + "img/celeri_branche_md.20ec6246.jpg";